import React from 'react';
import AgentDashboard from './AgentDashboard';

const ProductDashboard: React.FC = () => {
  const agentConfig = {
    id: 'product',
    displayName: 'Product',
    icon: '/assets/logos/aldo-product.png',
    color: '#10b981',
    description: 'Product information, support, and guidance',
    hasTestResults: false // Product agent doesn't have test results per requirement
  };

  return <AgentDashboard agentConfig={agentConfig} />;
};

export default ProductDashboard;
